import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CalendarPageRoutingModule } from './calendar-routing.module';

import { TranslateModule } from '@ngx-translate/core';
import { CalendarPage } from './calendar.page';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, CalendarPageRoutingModule, TranslateModule.forChild()],
  declarations: [CalendarPage]
})
export class CalendarPageModule {}

